module.exports = __webpack_public_path__ + "static/media/NOBAlogo.04c9f9fe.png";